import { CheckRounded, KeyboardArrowDownRounded } from '@mui/icons-material';
import { Box, CircularProgress, FormControl, FormHelperText, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Stack, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAsyncAction, useStateRef } from 'app/services';
import { transportGroupTypeFormLoad } from 'app/store/transport';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
const TransportGroupForm = forwardRef((props, ref) => {
    const { defaultValues, onSubmit } = props;
    const theme = useTheme();
    const [color, setColor] = useState(defaultValues ? defaultValues.color : theme.palette.primary.main);
    const { asyncAction: fetchTypeData, isLoading: isFetchTypeLoading } = useAsyncAction(transportGroupTypeFormLoad);
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
    const { groupTypeItems } = useSelector((state) => state.transport);
    const { reset, control, register, setValue, formState, handleSubmit } = useForm({
        defaultValues: {
            name: defaultValues ? defaultValues.name : '',
            color: defaultValues ? defaultValues.color : theme.palette.primary.main,
            type_id: defaultValues ? defaultValues.type_id : '',
        },
    });
    const handleColorChange = (value) => {
        setColor(value);
        setValue('color', value, { shouldDirty: true });
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                name: data.name,
                color: data.color,
                type_id: parseInt(String(data.type_id)),
            }))();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        if (defaultValues) {
            reset({
                name: defaultValues.name,
                color: defaultValues.color,
                type_id: defaultValues.type_id,
            });
            setColor(defaultValues.color);
        }
    }, [defaultValues]);
    useEffect(() => {
        fetchTypeData();
    }, []);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.name, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                    React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435', notched: !!firstUpdate, fullWidth: true, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B' }, register('name', {
                        pattern: /^([A-Za-zА-Яа-я0-9_\-\s]{3,255})$/iu,
                        required: true,
                        minLength: 3,
                    }))),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.role_id, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0422\u0438\u043F \u0433\u0440\u0443\u043F\u043F\u044B"),
                    isFetchTypeLoading && (React.createElement(OutlinedInput, { disabled: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchTypeLoading && (React.createElement(Controller, { name: 'type_id', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0422\u0438\u043F \u0433\u0440\u0443\u043F\u043F\u044B', defaultValue: '', IconComponent: KeyboardArrowDownRounded, MenuProps: {
                                sx: {
                                    '.MuiPaper-root:before': {
                                        display: 'none',
                                    },
                                },
                            } }, register(field.name, {
                            required: true,
                            pattern: /^([0-9]{1,11})?$/iu,
                        }), { notched: !!firstUpdate, value: field.value, onChange: field.onChange }), groupTypeItems.map((value, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, value: value.id }, value.label))))) })),
                    React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0433\u0440\u0443\u043F\u043F\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435")))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { error: !!formState.errors.color, margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                        marginBottom: theme.spacing(0),
                        '.MuiOutlinedInput-notchedOutline': {
                            borderBottom: '0',
                            borderBottomLeftRadius: '0',
                            borderBottomRightRadius: '0',
                        },
                        '.MuiOutlinedInput-root': {
                            color: 'text.primary',
                        },
                        '.MuiOutlinedInput-input': {
                            WebkitTextFillColor: 'currentColor',
                        },
                    }) },
                    React.createElement(InputLabel, { disableAnimation: true }, "\u0426\u0432\u0435\u0442 \u043C\u0430\u0440\u043A\u0435\u0440\u0430"),
                    React.createElement(OutlinedInput, { label: '\u0426\u0432\u0435\u0442 \u043C\u0430\u0440\u043A\u0435\u0440\u0430', value: color, disabled: true, notched: true, fullWidth: true, placeholder: '\u0426\u0432\u0435\u0442 \u043C\u0430\u0440\u043A\u0435\u0440\u0430' })),
                React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                        marginTop: '0',
                        '.react-colorful': {
                            width: '100%',
                            borderBottomLeftRadius: theme.shape.borderRadius * 2,
                            borderBottomRightRadius: theme.shape.borderRadius * 2,
                        },
                        '.react-colorful__saturation': {
                            boxShadow: 'inset 0px -1px 0px 1px rgb(0 0 0 / 15%)',
                            borderRadius: '0',
                        },
                        '.react-colorful__last-control': {
                            borderRadius: '0',
                        },
                    }) },
                    React.createElement(HexColorPicker, { color: color, onChange: handleColorChange }),
                    React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                            padding: theme.spacing(0.75),
                            backgroundColor: 'background.default',
                            borderBottomLeftRadius: theme.shape.borderRadius * 2,
                            borderBottomRightRadius: theme.shape.borderRadius * 2,
                        }) }, config.transportGroupPresetColors.map((value, key) => (React.createElement(Box, { component: 'div', key: key, onClick: () => handleColorChange(value), sx: Object.assign({ width: '24px', height: '24px', margin: '4px', border: 'none', padding: '0', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: value }, (color !== value && {
                            svg: {
                                display: 'none',
                                filter: 'invert(1)',
                            },
                        })) },
                        React.createElement(CheckRounded, { fontSize: 'small' }))))),
                    React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0432\u0435\u0442 \u0438\u0437 \u043F\u0430\u043B\u0438\u0442\u0440\u044B \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0431\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0446\u0432\u0435\u0442\u0430 \u043C\u0430\u0440\u043A\u0435\u0440\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0435."))))));
});
export default TransportGroupForm;
